var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitRiderIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_13689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0583 22.21V49.6604H1.49219V22.21",
    stroke: "#187C85",
    strokeWidth: 1.37431,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2734 33.8235V10.5962C18.6067 10.5962 20.4966 8.70633 20.4966 6.37305H31.0544C31.0544 8.70633 32.9443 10.5962 35.2776 10.5962V33.8235",
    stroke: "#187C85",
    strokeWidth: 1.37431,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7753 30.6562L50.0583 49.6604H1.49219L25.7753 30.6562Z",
    stroke: "#187C85",
    strokeWidth: 1.37431,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5215 35.9353L50.0581 22.2101L40.556 14.7773",
    stroke: "#187C85",
    strokeWidth: 1.37431,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0288 35.9353L1.49219 22.2101L10.9943 14.7773",
    stroke: "#187C85",
    strokeWidth: 1.37431,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9941 29.6005V1.09424H40.5562V29.6005",
    stroke: "#187C85",
    strokeWidth: 1.37431,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9441 15.8754C28.9441 14.1228 27.5293 12.708 25.7767 12.708C24.0241 12.708 22.6094 14.1228 22.6094 15.8754C22.6094 17.628 24.0241 19.0427 25.7767 19.0427C27.5293 19.0427 28.9441 20.4575 28.9441 22.2101C28.9441 23.9627 27.5293 25.3774 25.7767 25.3774C24.0241 25.3774 22.6094 23.9627 22.6094 22.2101",
    stroke: "#187C85",
    strokeWidth: 1.37431,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7773 12.7079V9.54053",
    stroke: "#187C85",
    strokeWidth: 1.37431,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7773 28.5448V25.3774",
    stroke: "#187C85",
    strokeWidth: 1.37431,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_13689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.6777,
    height: 50.6777,
    fill: "white",
    transform: "translate(0.4375 0.0385742)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitRiderIcon5);
export default __webpack_public_path__ + "static/media/benefit-rider-icon5.1538cd3f1c1130266c9117f45e6c7173.svg";
export { ForwardRef as ReactComponent };